import PropTypes from 'prop-types';

export const optionValue = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
]);

export const labelValueTuple = {
  label: PropTypes.string,
  value: optionValue,
};

export const radioOption = PropTypes.shape(labelValueTuple);

export const radioOptions = PropTypes.arrayOf(radioOption);

const linkEdge = PropTypes.shape({
  documentCode: PropTypes.string,
  adjustmentType: PropTypes.string,
  adjustmentDisplayName: PropTypes.string,
});

export const linkedAdjustmentsShape = PropTypes.shape({
  id: PropTypes.number,
  source: linkEdge,
  target: linkEdge,
  isBroken: PropTypes.bool,
});

export const structuredAnalysisShape = PropTypes.shape({
  dateModified: PropTypes.string,
  modifiedBy: PropTypes.string,
  versionNumber: PropTypes.number,
  userViewStatus: PropTypes.number,
  versionStatus: PropTypes.number,
});

export const tagShape = PropTypes.shape({
  id: PropTypes.number,
  text: PropTypes.string,
});

export const contentShape = PropTypes.shape({
  contentThreadId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  sortOrder: PropTypes.number,
  title: PropTypes.string,
  impact: PropTypes.string,
  status: PropTypes.string,
  dateModified: PropTypes.string,
  shareWithAll: PropTypes.bool,
  tags: PropTypes.arrayOf(tagShape),
});

export const sortAscending = 'asc';
export const sortDescending = 'desc';
export const sortDirShape = PropTypes.oneOf([sortAscending, sortDescending]);

export const contentTypeHypotheses = 'hypotheses';
export const contentTypeInsights = 'insights';
export const contentTypeAnalyses = 'analyses';
export const contentTypeShape = PropTypes.oneOf([
  contentTypeHypotheses,
  contentTypeInsights,
  contentTypeAnalyses,
]);
